module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Caitlin Ricci\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Caitlin is the author of over 150 queer romance books including some Rainbow Award winners. When she’s not writing, she enjoys gardening, hanging out with her dogs, and watching movies with her husband. She is a panromantic asexual and she lives on a small farm in Missouri where she enjoys the quiet life of a good cup of tea and her dogs asleep on the deck.")]), _c('P', [_vm._v("Website: www.CaitlinRicci.com")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/dhFej3/Images/cover.jpg?1684515369675",
      "alt": "This image is the cover for the book Of Monsters and Men, A Forever Home"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Of Monsters and Men, A Forever Home\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("A Forever Home: Book Two")])])]), _c('p', [_vm._v("Seth’s life looks idyllic on the surface. He has a great job at the pet rescue with a fantastic boss, who happens to be a werewolf. He is getting his degree at the local university and has a best friend who understands that the most intimate thing for Seth is a kiss. But when it comes to relationships, Seth’s perfect life is a jumbled mess. No guy stays around because eventually, they always want more than Seth, who is asexual, is able to give. Seth wants love and a relationship, but not the sex that everyone puts so much value on.")]), _c('p', [_vm._v("Seth tries for something more with the man he has a crush on, but when that ends Seth feels like he's back to square one. So when his boss's brother, Jeremy, pushes his way into Seth’s life, insisting that he won’t press for more than Seth is comfortable sharing, Seth is wary. All of Seth’s experience says it won’t last long. But Jeremy is one werewolf who is used to getting his way, and might just be patient enough to wait for Seth to see he means what he says.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0